import { useIsAnalysisInProgress } from '@/stores/analysisStatusStore';
import { caseActions, useIsBalanced, useIsBalancing } from '@/stores/caseStore';
import { useNodeCount, useParentPathwayId } from '@/stores/pathwayStore';
import { ScaleIcon } from '@heroicons/react/24/outline';
import { useReactFlow } from '@xyflow/react';

const BalanceButton = () => {
  const reactFlow = useReactFlow();
  const isBalanced = useIsBalanced();
  const nodeCount = useNodeCount();
  const isAnalysisInProgress = useIsAnalysisInProgress();
  const isBalancing = useIsBalancing();
  const parentPathwayId = useParentPathwayId();

  const balancePathway = async () => {
    try {
      await caseActions.balanceCase();
    } catch (error) {
      const nonFieldErrors = error?.response?.data?.non_field_errors;
      const hasUnconnectedNodes =
        Array.isArray(nonFieldErrors) &&
        nonFieldErrors.some(errorMsg => typeof errorMsg === 'string' && errorMsg.toLowerCase().includes('unconnected'));

      if (hasUnconnectedNodes) {
        reactFlow.fitView({
          duration: 600,
          maxZoom: 0.5,
          minZoom: 0.2,
          padding: 0.15,
        });
      }
    }
  };

  if (parentPathwayId || isBalanced || isAnalysisInProgress) {
    return null;
  }

  if (isBalancing) {
    return (
      <button className="btn btn-sm btn-secondary">
        <span className="loading loading-md"></span>
        Balancing
      </button>
    );
  }

  if (!isBalanced && nodeCount > 0) {
    return (
      <button onClick={balancePathway} className="btn btn-sm btn-accent">
        <ScaleIcon className="w-5 h-5" />
        Balance Pathway
      </button>
    );
  }

  return (
    <button className="btn btn-sm btn-accent btn-disabled">
      <ScaleIcon className="w-5 h-5" />
      Balance Pathway
    </button>
  );
};

export default BalanceButton;
